import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useQuery } from '@apollo/client/react'
// components
import DataPrivacyForm from './components/Form'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout'
// constants
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
// views
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// graphql
import { GET_COMPANY_PRIVACY_SETTINGS } from 'graphql/company/queries'
// utils
import { omit } from 'lodash'
import { IUserResponse } from 'types/graphql'

type QueryResponse = {
  userMe: IUserResponse
}

const DataPrivacy: React.FC = () => {
  const { data, loading } = useQuery<QueryResponse>(GET_COMPANY_PRIVACY_SETTINGS)

  const dataPrivacySettings = omit(data?.userMe.data.company.dataPrivacySettings, '__typename')

  return (
    <>
      <Helmet>
        <title>Skefto - API Settings</title>
      </Helmet>
      <MainLayoutContainer isLoading={loading}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <DataPrivacyForm initialValues={dataPrivacySettings} />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default DataPrivacy
